import { getBlockGap, getBlockGapX } from '$lib/global/helper/layout';
import { getShadow } from '$lib/global/helper/shadow';

import { getThemedOrCustomColor } from '../../_utils/getThemedOrCustomColor';

import type { BrandShadow, BrandSpacing, Theme } from '$lib/types/Theme';

export interface ResolvedReviewsStyling {
    avatarShadowClass: string | undefined;
    avatarBorderColor: string;
    blockGapXClass: string | undefined;
    blockGapYClass: string | undefined;
    textColor: string | undefined;
}

interface Params {
    theme: Theme | undefined;
    isInColumn: boolean;
    boxBackgroundColor: string | undefined;
}

const isMeaningfulColor = (value: string | undefined): value is string =>
    !!value && value !== 'transparent';

// Theming 2.0 only — per-block style overrides are not supported.
export const resolveReviewsStyling = ({
    theme,
    isInColumn,
    boxBackgroundColor,
}: Params): ResolvedReviewsStyling => {
    const avatarShadowClass = theme?.shadow
        ? getShadow('reviewsAvatar', theme.shadow as BrandShadow)
        : undefined;

    const blockGapXClass = theme?.blockGap
        ? getBlockGapX(theme.blockGap as BrandSpacing)
        : undefined;
    const blockGapYClass = theme?.blockGap
        ? getBlockGap(theme.blockGap as BrandSpacing)
        : undefined;

    let avatarBorderColor: string;

    if (isInColumn) {
        avatarBorderColor = 'white';
    } else if (isMeaningfulColor(boxBackgroundColor)) {
        avatarBorderColor = boxBackgroundColor;
    } else if (theme?.backgroundColor) {
        avatarBorderColor = theme.backgroundColor;
    } else {
        avatarBorderColor = getThemedOrCustomColor(
            boxBackgroundColor,
            'backgroundColor',
            theme as Theme,
        );
    }

    return {
        avatarShadowClass,
        avatarBorderColor,
        blockGapXClass,
        blockGapYClass,
        textColor: theme?.fontColor,
    };
};
